import React from "react"
import colors from "@digits-shared/themes/colors"
import { BodyText } from "@digits-shared/themes/typography"
import styled from "styled-components"

const NoTransactionsMessage = styled(BodyText)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 16px;
  color: ${colors.secondary60};
`

export const EmptyTransactionsTable: React.FC = () => (
  <NoTransactionsMessage>No transactions</NoTransactionsMessage>
)
